import React from "react";
import {injectIntl} from "react-intl";
import {VOICE_CHAT_TYPE} from "utils/constants";
import classNames from "classnames/bind";
import styles from "./index.module.scss";

const Header = ({
  intl,
  voiceChatType,
  miniMode,
  onClickViewMode,
  onClickTypeTab,
}) => {
  const cn = classNames.bind(styles);

  return (
    <div className={cn("voice_chat_header", miniMode && "mini_mode")}>
      <ul className={cn("type_tab")}>
        {VOICE_CHAT_TYPE.map((type, i) => {
          if (i === 2) return null;
          return (
            <li
              key={i}
              onClick={() => onClickTypeTab(type)}
              className={cn(voiceChatType === type && "active")}
            >
              {intl.formatMessage({id: `ID_VOICE_CHAT_TAB_${type}`})}
            </li>
          );
        })}
      </ul>
      <button
        type="button"
        className={cn("header_btn")}
        onClick={onClickViewMode}
      >
        <div />
        {miniMode && <div />}
      </button>
    </div>
  );
};

export default injectIntl(Header);
